import localDB from "./localDB";

let GLOBAL = require('./globals');

const CloseBoxData = {
    async open(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/open-box-current`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async getCurrent() {
        const response = await fetch(`${GLOBAL.BASE_URL}api/open-box-current`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async put(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/open-box-current`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async get(id) {
        const response = await fetch(`${GLOBAL.BASE_URL}api/open-box/${id}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
};

export default CloseBoxData;



// WEBPACK FOOTER //
// ./src/data/CloseBoxData.js